import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReviewWrapper } from './ReviewsWrapper';
import { PatientReviewsText, ReviewsLegend } from './ReviewsHeader';
import { LOCALIZED_STRINGS } from '../constants';

export default () => (
    <ReviewWrapper data-test="opt-out-reviews">
        <PatientReviewsText>
            <FormattedMessage {...LOCALIZED_STRINGS.ReviewsHeader} />
        </PatientReviewsText>
        <ReviewsLegend>
            <FormattedMessage
                {...LOCALIZED_STRINGS.ProviderOptedOut}
            />
        </ReviewsLegend>
    </ReviewWrapper>
);
